import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Services from "@/components/Services";
import Hours from "@/components/Hours";
import Scholarships from "@/components/Scholarships";
import ParentInfo from "@/components/ParentInfo";
import WhyUs from "@/components/WhyUs";
import Enrollment from "@/components/Enrollment";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Home = () => {
  useEffect(() => {
    document.title = "Pieces to Our Puzzle Childcare | Childcare in Halethorpe, MD — Open 7 Days a Week";
  }, []);

  return (
    <main className="bg-sand">
      <Header />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Hours />
      <Scholarships />
      <ParentInfo />
      <WhyUs />
      <Enrollment />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
